import React, { memo } from 'react';
import AgendaFilterbar from './AgendaFilterbar';
import CoursesFilterbar from './CoursesFilterbar';

const AgendaFilters = ({
	memoizedFilteredCount,

	memoizedActiveFilterDate,
	memoizedActiveTimestamp,
	memoizedDateRange,
	memoizedActiveLocations,
	memoizedActiveCategories,
	memoizedActiveAudiences,
	memoizedActiveTags,
	memoizedActiveWeekdays,
	memoizedIsFree,
	memoizedIsDiscount,

	availableDates,
	availableLocations,
	availableCategories,
	availableAudiences,
	availableTags,

	memoizedAvailableLocationsFiltered,
	memoizedAvailableCategoriesFiltered,
	memoizedAvailableAudiencesFiltered,
	memoizedAvailableTagsFiltered,

	setDateParam,
	setDateRangeParam,
	setLocationsParam,
	setTagsParam,
	setAudiencesParam,
	setCoursesAudienceParam,
	setCategoriesParam,
	setCoursesTagsParam,
	setCoursesWeekdaysParam,
	setFreeParam,
	setDiscountParam,
	resetParams,

	config,
	showModal,
	setShowModal,

}) => {

	const displayAmountActiveFilters = () => {
		let counter = 0;
		counter += memoizedActiveLocations.length + memoizedActiveCategories.length + memoizedActiveAudiences.length + memoizedActiveTags.length + memoizedActiveWeekdays.length + (memoizedIsFree ? 1 : 0) + (memoizedIsDiscount ? 1 : 0);
		if (counter <= 0) return '';
		return counter;
	};

	const toggleModal = () => {
		setShowModal(!showModal);
	};

	const handleParamClick = (value, group, disabled, active) => {
		if (!disabled || active){
			if (group === 'location') {
				setLocationsParam(value);
				return;
			}
			if (group === 'category') {
				setCategoriesParam(value);
				return;
			}
			if (group === 'audience') {
				setAudiencesParam(value);
				return;
			}
			if (group === 'tag') {
				setTagsParam(value);
			}
		}
	}

	const handleCourseFilter = (value, group) => {
		if (group === 'audience') {
			setCoursesAudienceParam(value);
			return;
		}
		if (group === 'tag') {
			setCoursesTagsParam(value);
			return;
		}
		if (group = 'weekday') {
			setCoursesWeekdaysParam(value);
		}
	}

	//returns a param object with value, active and disabled keys
	const getParamLabels = (group) => {
		if (group === 'location') {
			return availableLocations.map((location) => {
				return {
					value: location,
					name: Object.values(location)[0],
					active: memoizedActiveLocations.includes(location),
					disabled: memoizedAvailableLocationsFiltered && !memoizedAvailableLocationsFiltered.includes(location),
				}
			});
		}
		if (group === 'category') {
			return availableCategories.map((category) => {
				return {
					value: category,
					name: Object.values(category)[0],
					active: memoizedActiveCategories.includes(category),
					disabled: memoizedAvailableCategoriesFiltered && !memoizedAvailableCategoriesFiltered.includes(category),
				}
			});
		}
		if (group === 'audience') {
			return availableAudiences.map((audience) => {
				return {
					value: audience,
					name: Object.values(audience)[0],
					active: memoizedActiveAudiences.includes(audience),
					disabled: memoizedAvailableAudiencesFiltered && !memoizedAvailableAudiencesFiltered.includes(audience),
				}
			});
		}
		if (group === 'tag') {
			return availableTags.map((tag) => {
				return {
					value: tag,
					name: Object.values(tag)[0],
					active: memoizedActiveTags.includes(tag),
					disabled: memoizedAvailableTagsFiltered && !memoizedAvailableTagsFiltered.includes(tag),
				}
			});
		}
	}

	const getActiveLabels = () => {
		const labels = [];
		[memoizedActiveLocations, memoizedActiveCategories, memoizedActiveAudiences, memoizedActiveTags, memoizedActiveWeekdays].forEach((filter) => {
			filter.forEach((value) => {
				labels.push({value: value, name: Object.values(value)[0], group: filter});
			});
		});
		return labels;
	}

	const handleFreeClick = (e) => {
		setFreeParam(e.target.checked);
	}

	const handleDiscountClick = (e) => {
		setDiscountParam(e.target.checked);
	}

	const removeLabel = (value, group) => {
		console.log(group, value)
		if (group === memoizedActiveLocations) {
			setLocationsParam(value);
		}
		if (group === memoizedActiveCategories) {
			setCategoriesParam(value);
		}
		if (group === memoizedActiveAudiences) {
			setAudiencesParam(value);
		}
		if (group === memoizedActiveTags) {
			setTagsParam(value);
		}
		if (group === memoizedActiveWeekdays) {
			setCoursesWeekdaysParam(value);
		}
	}

	const handleTagClass = (param)=>{
		let className = 'tag';
		if (param.active) {
			className += ' tag--active';
		} else if (param.disabled) {
			className += ' tag--disabled';
		}
		return className
	}

	if (config.filterbar_type === 'overlay') {
		return <AgendaFilterbar
			memoizedFilteredCount={memoizedFilteredCount}
			memoizedActiveFilterDate={memoizedActiveFilterDate}
			memoizedActiveTimestamp={memoizedActiveTimestamp}
			memoizedDateRange={memoizedDateRange}
			memoizedActiveLocations={memoizedActiveLocations}
			memoizedActiveCategories={memoizedActiveCategories}
			memoizedActiveAudiences={memoizedActiveAudiences}
			memoizedActiveTags={memoizedActiveTags}
			memoizedIsFree={memoizedIsFree}
			memoizedIsDiscount={memoizedIsDiscount}
			availableDates={availableDates}

			showModal={showModal}
			toggleModal={toggleModal}
			handleParamClick={handleParamClick}
			getParamLabels={getParamLabels}
			getActiveLabels={getActiveLabels}
			handleFreeClick={handleFreeClick}
			handleDiscountClick={handleDiscountClick}
			removeLabel={removeLabel}
			handleTagClass={handleTagClass}
			setDateParam={setDateParam}
			setDateRangeParam={setDateRangeParam}
			resetParams={resetParams}
			config={config}
			displayAmountActiveFilters={displayAmountActiveFilters}
		/>
	}

	if (config.filterbar_type === 'dropdowns') {
		return <CoursesFilterbar
			availableAudiences={availableAudiences}
			availableTags={availableTags}

			memoizedActiveAudiences={memoizedActiveAudiences}
			memoizedActiveTags={memoizedActiveTags}
			memoizedActiveWeekdays={memoizedActiveWeekdays}

			handleCourseFilter={handleCourseFilter}
			getActiveLabels={getActiveLabels}
			removeLabel={removeLabel}
			resetParams={resetParams}
			config={config}
			displayAmountActiveFilters={displayAmountActiveFilters}
		/>
	}
};

export default memo(AgendaFilters);
